import React from 'react'
import BlueBoxSection from '../Slices/BlueBoxSection'
import LogoCallToAction from '../Slices/LogoCallToAction'
import FullImageSection from '../Slices/FullImageSection'
import NewsCarousel from '../Slices/NewsCarousel'
import Advertisement from '../Slices/Advertisement'
import GridTypeOne from '../Slices/GridTypeOne'
import GridTypeTwo from '../Slices/GridTypeTwo'
import Tabs from '../Slices/TabSection'
import Bios from '../Slices/Bios'
import RichTextSlice from '../Slices/RichTextSlice'
import ImageLinkBoxes from '../Slices/ImageLinkBoxes'
import Accordion from '../Slices/Accordion'

// passing in the location prop from Resources.js so we can automatically select tabs on that page based on the url
const SliceZone = ({ sliceZone, location }) => {
    const sliceComponents = {
        blue_box_section: BlueBoxSection,
        logo_call_to_action: LogoCallToAction,
        full_image_section: FullImageSection,
        news_carousel: NewsCarousel,
        advertisement: Advertisement,
        grid_type_1: GridTypeOne,
        grid_type_2: GridTypeTwo,
        tabs: Tabs,
        staff_board_bios: Bios,
        rich_text_slice: RichTextSlice,
        image_link_boxes: ImageLinkBoxes,
        accordion: Accordion,
    }

    const pageLocation = location
    //console.log(`location: ${pageLocation}`)

    const sliceZoneContent = sliceZone.map((slice, index, location ) => {
        const SliceComponent = sliceComponents[slice.slice_type]
        if (SliceComponent) {
          
          return <SliceComponent slice={slice} key={`slice-${index}`} location={pageLocation} />
        }
        return null
      })
    
      return <div>{sliceZoneContent}</div>
    }

export default SliceZone